import * as React from "react";
import Table from "../../controls/Table";

const SiteSetupTable = ({ linksList, onItemDeleteClick }) => {
    const itemsPerPage = 25;

    function formatDeleteSignInCell(cell, row){
        if (row.isActive) {
            return (
                <div className="icon icon-cancel" onClick={() => {
                    if(onItemDeleteClick) {
                        onItemDeleteClick(cell);
                    }}} />
            );
        } else {
            return <div className="icon" />;
        }
    }

    const columns = [
        {
            isKey: false,
            dataAlign: "left",
            dataField: "site",
            label: "Site Id",
            width: "19%",
            dataSort: true,
            sort: "asc"
        }, {
            isKey: false,
            dataAlign: "left",
            dataField: "siteName",
            label: "Site Name",
            width: "28%",
            dataSort: true
        }, {
            isKey: false,
            dataAlign: "left",
            dataField: "login",
            label: "User Id",
            width: "20%",
            dataSort: true
        }, {
            isKey: false,
            dataAlign: "left",
            dataField: "userName",
            label: "User Name",
            width: "28%",
            dataSort: true
        }, {
            isKey: false,
            dataAlign: "left",
            dataField: "isActive",
            label: "",
            width: "0",
            hidden: true
        }, {
            isKey: true,
            dataAlign: "right",
            dataField: "id",
            width: "36px",
            dataFormat: formatDeleteSignInCell,
            label:" "
        }
    ];

    const inactiveRowFormatter = (row, index) => {
        return row.isActive ? "" : 'inactive';
    };

    return (
        <div id="SiteSetupTable">
            <Table
                data={linksList}
                search={false}
                columns={columns}
                options={{
                    sizePerPage: itemsPerPage,
                    sizePerPageList: [],
                    sortOrder: "asc",
                    sortName: "siteName"
                }}
                bordered={false}
                pagination={true}
                striped={false}
                hover={false}
                trClassName={inactiveRowFormatter}
            />
        </div>
    );
};

export default SiteSetupTable;
